export const DELIVERY = 'DELIVERY'
export const PICKUP = 'PICKUP'
export const COUNTER = 'COUNTER'
export const RESTAURANT = 'RESTAURANT'
